export default function validateYoutubeUrl(url) {
  const results = url.match(
    /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
  )

  if (results && results.length) {
    return results[1]
  }

  return false
}
